import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { utcToTimezone } from 'helpers/dates';
import { usePaginationControls } from 'helpers/hooks';
import { useApp } from 'providers/AppProvider';
import { SORT_BY } from 'constants/opportunities';
import { useDashboardFollowedProjectsSearch } from '../hooks';
import DashboardDataTable from '../DashboardDataTable';
import DashboardDataTableLinkCell from '../DashboardDataTable/DashboardDataTableLinkCell';

// TODO: PV-1382.
const DashboardFollowing = () => {
  const { t } = useTranslation();
  const { timezone } = useApp();
  const [search, setSearch] = useState('');
  const [sortBy] = useState({ sort: SORT_BY.mostRecent, direction: 'desc' });
  const { paginationProps, paginationState, setTotalItems } = usePaginationControls({
    initialTotalItems: 0,
  });
  const { followedProjects, totalCount } = useDashboardFollowedProjectsSearch({
    limit: paginationState.size,
    page: paginationState.page,
    search,
    ...sortBy,
  });

  useEffect(() => {
    setTotalItems(totalCount);
  }, [totalCount, setTotalItems]);

  const columns = useMemo(
    () => [
      {
        id: 'ReferenceID',
        label: t('dashboard.data_table.ref_num'),
        isSortable: true,
        render: 'string',
      },
      {
        id: 'ProjectName',
        label: t('dashboard.data_table.project_name'),
        isSortable: true,
        render: 'string',
      },
      {
        id: 'OrganizationName',
        label: t('dashboard.data_table.organization_name'),
        isSortable: true,
        render: row => row.Organization.OrganizationName,
      },
      {
        id: 'DateOpen',
        label: t('dashboard.data_table.date_project_open'),
        isSortable: true,
        render: row => utcToTimezone(row.DateOpen, { timezone, format: 'DD MMM YYYY, h:mma z' }),
      },
      {
        id: 'DateClose',
        label: t('dashboard.data_table.date_project_close'),
        isSortable: true,
        render: row => utcToTimezone(row.DateClose, { timezone, format: 'DD MMM YYYY, h:mma z' }),
      },
      {
        id: 'DateQuestionsDue',
        label: t('dashboard.data_table.date_questions_due'),
        isSortable: true,
        render: row =>
          row.DateQuestionsDue
            ? utcToTimezone(row.DateQuestionsDue, { timezone, format: 'DD MMM YYYY, h:mma z' })
            : '-',
      },
    ],
    [t, timezone]
  );

  const rowGetter = useCallback(
    async ({ search }) => {
      setSearch(search);
      return followedProjects;
    },
    [followedProjects]
  );

  const fileGetter = useCallback(() => console.log('TODO: PV-1384'), []);

  return (
    <>
      <DashboardDataTable
        count={paginationState.total}
        title={t('dashboard.following.title')}
        DataTableProps={{
          fileGetter,
          rowGetter,
          columns,
          linkRenderer: row => <DashboardDataTableLinkCell row={row} type="following" />,
          caption: t('dashboard.following.data_table.caption'),
        }}
      />
      <DashboardDataTable.Pagination
        PaginationControlsProps={{
          ...paginationProps,
          page: paginationState.page,
          totalItems: paginationState.total,
        }}
      />
    </>
  );
};

export default DashboardFollowing;
